import { Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { TextContent } from '../../models/text-content.model';
import { GlobalElementType } from '../../enums/global-element-type-uid.enum';

@Component({
  selector: 'vm-countdown-section',
  templateUrl: './countdown-section.component.html',
  styleUrls: ['./countdown-section.component.scss'],
})
export class CountdownSectionComponent implements OnInit, OnDestroy {
  @Input() data: TextContent;
  globalElementType = GlobalElementType;

  @Input() endDate!: Date;
  @Output() timerEnded = new EventEmitter();

  @HostBinding('class.countdown')
  protected readonly hbClassCountdown = true;

  @HostBinding('attr.role')
  protected readonly role = 'timer';

  readonly calcMinute = 1000 * 60;
  readonly calcHour = this.calcMinute * 60;
  readonly calcDay = this.calcHour * 24;

  days!: number;
  hours!: number;
  minutes!: number;
  seconds!: number;

  _secondsInterval: Subscription = interval(1000).subscribe(() => this.updateCountdown());
  endTime!: number;

  @HostBinding('attr.aria-label')
  get ariaLabel() {
    return `Countdown: ${Math.floor(this.days)} ${this.pluralise('day', Math.floor(this.days))}, ${Math.floor(
      this.hours
    )} ${this.pluralise('hour', Math.floor(this.hours))}, ${Math.floor(this.minutes)} ${this.pluralise(
      'minute',
      Math.floor(this.minutes)
    )} remaining`;
  }

  pluralise(word: string, count: number) {
    return count === 1 ? word : `${word}s`;
  }

  endTimer() {
    if (this._secondsInterval) {
      this._secondsInterval.unsubscribe();
    }
  }

  calculateOutput(distance: number) {
    this.days = distance / this.calcDay;
    this.hours = (distance % this.calcDay) / this.calcHour;
    this.minutes = (distance % this.calcHour) / this.calcMinute;
    this.seconds = (distance % this.calcMinute) / 1000;
  }

  updateCountdown() {
    const currentTime = new Date().getTime();
    const distance = this.endTime - currentTime;

    if (distance <= 0) {
      this.endTimer();
      this.timerEnded.emit();
      return;
    }

    this.calculateOutput(distance);
  }

  ngOnInit() {
    this.calculateOutput(0);
    this.endTime = this.endDate.getTime();
  }

  ngOnDestroy() {
    this.endTimer();
  }
}
